/**
 * Utility functions for formatting strings
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */

/**
 * Returns a formatted full name based on whether or not a proper first or last name are provided
 * @param {String} firstName The first name
 * @param {String} lastName The last name
 */
export const getFullName = (firstName = '', lastName = '') => {
  const formattedName = `${firstName} ${lastName}`

  return formattedName.trim()
}
